<label [attr.for]="inputId"
       #label
       class="p-l-3 p-r-3 p-t-4 p-b-4 block cursor-pointer">
    <div class="flex flex-top p-l-1">
        <input #input
               class="visually-hidden"
               [id]="inputId"
               type="radio"
               [required]="required"
               [checked]="checked"
               [attr.value]="value"
               [disabled]="disabled"
               [attr.name]="name"
               [attr.aria-label]="ariaLabel || null"
               [attr.aria-labelledby]="ariaLabelledby"
               (change)="onInputChange($event)">

        <i [ngClass]="checked ? 'icon-radio-on' : 'icon-radio-off'"
           class="col-1 radio__icon"></i>

        <div class="radio__content flex-grow m-l-3">
            <!-- Use either radioBody to have own stylijng or regular content to have default one -->
            <ng-content select="[radioBody]"></ng-content>
            <div class="flex flex-top flex-grow">
                <p class="s1 flex-grow">
                    <ng-content select="[radioTitle]"></ng-content>
                </p>
                <p class="p1">
                    <ng-content select="[radioAside]"></ng-content>
                </p>
            </div>
        </div>
    </div>
    <div class="p2">
        <ng-content select="[radioBottom]"></ng-content>
    </div>
</label>
